import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledTableWrapper = styled.div<{ withBottomBorder?: boolean }>`
    & .MiniFlexTable-cell {
        ${setFontVariant("input2")}
    }
    & .StyledTable {
        padding-bottom: 0;
    }
    & .StyledTable .MiniFlexTable-column {
        .MiniFlexTable-cell {
            padding-left: 16px;
        }
    }
    & .StyledTable .MiniFlexTable-column:last-of-type {
        flex-shrink: 0 !important;
        & .MiniFlexTable-headerCell {
            padding-right: 0;
        }
    }
    & .StyledTable .MiniFlexTable-column:first-of-type {
        & .MiniFlexTable-headerCell,
        .MiniFlexTable-cell {
            padding-left: 0;
        }
    }
    & .MiniFlexTable-headerCell {
        align-items: flex-start !important;
        height: 28px !important;
        & .headerCell-text {
            ${setFontVariant("captionTitle", colorsPalettes.carbon[400])}
        }
    }
    ${({ withBottomBorder }) =>
        withBottomBorder &&
        css`
            .StyledTable .MiniFlexTable-column .MiniFlexTable-cell:last-of-type {
                border-bottom: 1px solid ${colorsPalettes.carbon[50]};
            }
        `}
`;
